import { RoutePath } from '@components/AppRouter/constants';
import type { Route } from '@components/AppRouter/types';

export const dictionaryConfig: Route = {
  title: 'Справочники',
  icon: 'dictionaryHome',
  routes: [
    {
      title: 'Основные',
      resourceName: ['CmOrganization', 'CmReportPeriods'],
      routes: [
        {
          title: 'Общая информация об организации',
          path: `${RoutePath.ORGANIZATION_CARD}/:code`,
          resourceName: 'CmOrganization',
          hidden: true,
        },
        {
          title: 'Организационная структура',
          path: RoutePath.ORGANIZATIONS,
          resourceName: 'CmOrganization',
        },
        {
          title: 'Календарь отчетных форм',
          path: RoutePath.DICTIONARY_REPORT_PERIODS,
          resourceName: 'CmReportPeriods',
        },
        {
          path: `${RoutePath.DICTIONARY_REPORT_PERIODS}/:reportGroupCode/:periodCode?`,
          hidden: true,
          resourceName: 'CmReportPeriods',
        },
        {
          title: 'Контрагенты',
          path: RoutePath.DICTIONARY_COUNTERPARTIES,
          resourceName: 'CmPartners',
        },
        {
          path: `${RoutePath.DICTIONARY_COUNTERPARTIES}/:code/:counterpartyTypeCode?/:orgLocal?`,
          hidden: true,
          resourceName: 'CmPartners',
        },
      ],
    },
    {
      title: 'Отчетность',
      resourceName: ['CmReport', 'CmReportVersion', 'CmReportSettings', 'CmReportGroup'],
      routes: [
        {
          title: 'Группы отчетности',
          path: RoutePath.DICTIONARY_REPORT_GROUPS,
          resourceName: 'CmReportGroup',
        },
        {
          path: `${RoutePath.DICTIONARY_REPORT_GROUPS}/:code`,
          hidden: true,
          resourceName: 'CmReportGroup',
        },
        {
          title: 'Отчеты',
          path: RoutePath.DICTIONARY_REPORT,
          resourceName: 'CmReport',
        },
        {
          path: `${RoutePath.DICTIONARY_REPORT}/:code`,
          hidden: true,
          resourceName: 'CmReport',
        },
        {
          title: 'Версии отчетов',
          path: RoutePath.DICTIONARY_REPORT_VERSION,
          resourceName: 'CmReportVersion',
        },
        {
          path: `${RoutePath.DICTIONARY_REPORT_VERSION}/:code`,
          hidden: true,
          resourceName: 'CmReportVersion',
        },
        {
          title: 'Настройка отчетов',
          path: RoutePath.DICTIONARY_REPORT_SETTINGS,
          resourceName: 'CmReportSettings',
        },
        {
          path: `${RoutePath.DICTIONARY_REPORT_SETTINGS}/:code`,
          hidden: true,
          resourceName: 'CmReportSettings',
        },
      ],
    },
    {
      title: 'Бизнес-контроли',
      resourceName: ['CmControl', 'CmControlVersion', 'CmIndicator', 'CmControlApplicability', 'CmGroupControl'],
      routes: [
        {
          title: 'Группы контролей',
          path: RoutePath.DICTIONARY_CONTROL_GROUPS,
          resourceName: 'CmGroupControl',
        },
        {
          path: `${RoutePath.DICTIONARY_CONTROL_GROUPS}/:ctrlGroupCode`,
          hidden: true,
          resourceName: 'CmGroupControl',
        },
        {
          title: 'Контроли',
          path: RoutePath.DICTIONARY_CONTROLS,
          resourceName: 'CmControl',
        },
        {
          path: `${RoutePath.DICTIONARY_CONTROLS}/:ctrlCode`,
          hidden: true,
          resourceName: 'CmControl',
        },
        {
          title: 'Версии контролей',
          path: RoutePath.DICTIONARY_CONTROL_VERSIONS,
          resourceName: 'CmControlVersion',
        },
        {
          path: `${RoutePath.DICTIONARY_CONTROL_VERSIONS}/:ctrlVersCode`,
          hidden: true,
          resourceName: 'CmControlVersion',
        },
        {
          title: 'Показатели',
          path: RoutePath.DICTIONARY_INDICATORS,
          resourceName: 'CmIndicator',
        },
        {
          path: `${RoutePath.DICTIONARY_INDICATORS}/:varCode`,
          hidden: true,
          resourceName: 'CmIndicator',
        },
        {
          title: 'Применимости контролей',
          path: RoutePath.DICTIONARY_CONTROL_APPLICABILITY,
          resourceName: 'CmControlApplicability',
        },
        {
          path: `${RoutePath.DICTIONARY_CONTROL_APPLICABILITY}/:ctrlVersCode/:orgCode?`,
          hidden: true,
          resourceName: 'CmControlApplicability',
        },
      ],
    },
  ],
};
